import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, computed, input, OnDestroy, signal, ViewChild, ViewContainerRef } from '@angular/core';
import { FilterBaseComponent } from './filter-base-component.class';
import { IFilter, IFilterComponentRef, IFilterItem } from '../interfaces';
import { FilterType } from '@nha/enums/filter-type.enum';

@Component({
	selector: 'nha-filter-base-slide',
	template: ''
})
export abstract class FilterBaseSlideComponent extends FilterBaseComponent implements AfterViewInit, OnDestroy {
	@ViewChild('custom', { read: ViewContainerRef })
	customContainer: ViewContainerRef;
	private customComponentRef: ComponentRef<any> | null = null;

	custom = input<IFilterComponentRef>();

	isSlider = computed(() => this.filter().filterDisplayType === FilterType.Slider);
	sliderData = computed(() => this.filter().items[0].data);
	selected = computed<number>(() => {
		const selectedItems = this.filter().items.filter((i) => i.selected);
		if (selectedItems.length === 0) {
			return 0;
		}
		return Math.min(...selectedItems.map((item) => item.data.value));
	});

	highSelected = computed<number>(() => {
		const selectedItems = this.filter().items.filter((i) => i.selected);
		if (selectedItems.length === 0) {
			return 0;
		}
		return Math.max(...selectedItems.map((item) => item.data.value));
	});

	isCustom = computed(() => this.custom() !== undefined);

	searchTerm = signal<string | null>(null);

	filterItems = computed(() => {
		if (this.searchTerm()) {
			const term = this.searchTerm().toLowerCase();
			return this.filter().items.filter((i) => i.label.toString().toLowerCase().includes(term));
		}

		return this.filter().items;
	});

	constructor(protected readonly _cdr: ChangeDetectorRef) {
		super();
	}

	ngAfterViewInit(): void {
		if (this.isCustom()) {
			this.customContainer.clear();
			this.customComponentRef = this.customContainer.createComponent(this.custom().component);
			(<FilterBaseComponent>this.customComponentRef.instance).filter = this.filter;
			(<FilterBaseComponent>this.customComponentRef.instance).counts = this.counts;
			(<FilterBaseComponent>this.customComponentRef.instance).filterKey = this.filterKey;
			(<FilterBaseComponent>this.customComponentRef.instance).key = this.key;

			this._cdr.detectChanges();
		}
	}

	ngOnDestroy(): void {
		if (this.customComponentRef) {
			this.customComponentRef.destroy();
			this.customComponentRef = null;
		}
		super.ngOnDestroy();
	}

	selectSliderValue(value: number): void {
		const item: IFilterItem = this.filter().items.find((i) => i.id === value);
		this.select(this.filterKey(), this.filter(), item.id);
	}

	selectSliderLowValue(selection: number): void {
		const currentFilter = this.filter();
		const highSelected = this.highSelected() ?? selection;

		const updatedItems = currentFilter.items.map((item) => {
			if (currentFilter.items[0].data.clearOnZero && selection === 0) {
				return { ...item, selected: false };
			}
			return {
				...item,
				selected: item.data.value >= selection && item.data.value <= highSelected
			};
		});

		const updatedFilter: IFilter = {
			...currentFilter,
			items: updatedItems
		};

		this.filterState.updateFilter(this.key(), this.filterKey(), updatedFilter);
	}

	selectSliderHighValue(selection: number): void {
		const lowSelected = this.selected() ?? 0;
		const currentFilter = this.filter();

		const updatedItems = currentFilter.items.map((item) => {
			if (currentFilter.items[0].data.clearOnZero && selection === 0) {
				return { ...item, selected: false };
			}
			return {
				...item,
				selected: item.data.value >= lowSelected && item.data.value <= selection
			};
		});

		const updatedFilter: IFilter = {
			...currentFilter,
			items: updatedItems
		};

		this.filterState.updateFilter(this.key(), this.filterKey(), updatedFilter);
	}
}
